/* World B — minimale Interaktionen (FAQ-Akkordeon, Wisch-Punkte, Mehr-laden).
   Nur auf .world-b/wb-Elemente gescoped, kollidiert nicht mit Dawn. */
(function () {
  'use strict';

  function initFaq(root) {
    (root || document).querySelectorAll('.world-b .faq-item').forEach(function (item) {
      if (item.dataset.wbBound) return;
      item.dataset.wbBound = '1';
      item.addEventListener('click', function () {
        item.classList.toggle('open');
      });
    });
  }

  /* Punkt-Indikatoren für Wisch-Reihen ([data-wb-dots]) */
  function initDots(root) {
    (root || document).querySelectorAll('[data-wb-dots]').forEach(function (row) {
      if (row.dataset.wbDotsBound) return;
      row.dataset.wbDotsBound = '1';
      var cards = Array.prototype.slice.call(row.children);
      if (cards.length < 2) return;
      var dots = document.createElement('div');
      dots.className = 'wb-dots';
      cards.forEach(function (card, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Karte ' + (i + 1));
        if (i === 0) b.classList.add('on');
        b.addEventListener('click', function () {
          row.scrollTo({ left: card.offsetLeft - row.offsetLeft, behavior: 'smooth' });
        });
        dots.appendChild(b);
      });
      row.after(dots);
      row.addEventListener('scroll', function () {
        var step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : 1;
        var idx = Math.min(cards.length - 1, Math.max(0, Math.round(row.scrollLeft / step)));
        dots.querySelectorAll('button').forEach(function (d, i) {
          d.classList.toggle('on', i === idx);
        });
      }, { passive: true });
    });
  }

  /* Kollektionsseite: "Mehr laden" statt Seitenzahlen */
  function initLoadMore() {
    var grid = document.getElementById('product-grid');
    var wrapper = document.querySelector('.pagination-wrapper');
    if (!grid || !wrapper || wrapper.dataset.wbLoadmore) return;
    var next = wrapper.querySelector('.pagination__item--next');
    if (!next) return;
    wrapper.dataset.wbLoadmore = '1';
    wrapper.classList.add('wb-lm-active');

    var box = document.createElement('div');
    box.className = 'wb-loadmore-box';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wb-loadmore';
    btn.textContent = 'Mehr laden';
    var count = document.createElement('span');
    count.className = 'wb-loadmore-count';
    box.appendChild(btn);
    box.appendChild(count);
    wrapper.after(box);

    function total() {
      var el = document.getElementById('ProductCount') || document.getElementById('ProductCountDesktop');
      if (!el) return null;
      var m = el.textContent.replace(/\./g, '').match(/\d+/);
      return m ? parseInt(m[0], 10) : null;
    }
    function updateCount() {
      var shown = grid.querySelectorAll(':scope > li').length;
      var t = total();
      count.textContent = t ? shown + ' von ' + t + ' Produkten' : shown + ' Produkte geladen';
    }
    updateCount();

    var nextUrl = next.href;
    btn.addEventListener('click', function () {
      if (!nextUrl) return;
      btn.disabled = true;
      btn.textContent = 'Lädt …';
      fetch(nextUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('product-grid');
          if (newGrid) {
            Array.prototype.slice.call(newGrid.children).forEach(function (li) {
              grid.appendChild(li);
            });
          }
          var newNext = doc.querySelector('.pagination__item--next');
          nextUrl = newNext ? newNext.href : null;
          if (!nextUrl) box.classList.add('wb-lm-done');
          btn.disabled = false;
          btn.textContent = 'Mehr laden';
          updateCount();
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = 'Mehr laden';
          window.location.href = nextUrl;
        });
    });
  }

  function initAll(root) {
    initFaq(root);
    initDots(root);
    initLoadMore();
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  }

  // Theme-Editor: neu geladene Sections erneut binden
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
